import { Box } from "@mui/material";
import React from "react";
import { asArray, getValue } from "../utils/tools";

const ErrorFallback = ({ error }) => {
  return (
    <Box className={"RenderError"}>
      Something went wrong. ({getValue(error, "message")})
    </Box>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const Error = this.props.fallback || ErrorFallback;
      return <Error error={this.state.error} />;
    }

    return this.props.children;
  }
}

export function withErrorBoundaryConstructor(ComponentConstructor, fallback) {
  return function WrappedWithErrorBoundary(props) {
    return (
      <ErrorBoundary fallback={fallback}>
        <ComponentConstructor {...props} />
      </ErrorBoundary>
    );
  };
}

export function withErrorBoundaryInstance(ComponentInstance, fallback, idx) {
  return ComponentInstance ? (
    <ErrorBoundary {...ComponentInstance.props} key={idx} fallback={fallback}>
      {ComponentInstance}
    </ErrorBoundary>
  ) : null;
}

export function withErrorBoundaryManyInstance(components, fallback) {
  const res = asArray(components).map((Component, idx) =>
    withErrorBoundaryInstance(Component, fallback, idx)
  );
  return res;
}
